import {InventoryStemEdit} from '@/admin/resources/inventoryStems/InventoryStems';

export default {
  edit: InventoryStemEdit,
};
